import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

import appVisibility from '~/configs/api/axios/helpers/appVisibility';

// export const handleTimeoutError = (error: AxiosError) => {
//   try {
//     return handleTimeoutErrorFactory((_error: AxiosError) => {
//       alertErrorMessage(
//         '네트워크 연결 상태가\n원활하지 않습니다.\n잠시 후 다시 시도해 주세요.\n'
//       );
//       throw new TimeoutError(_error);
//     })(error);
//   } catch (e) {
//     return e;
//   }
// };

// export const handleKickoutError = (error: AxiosError) => {
//   try {
//     return handleKickoutErrorFactory()(error);
//   } catch (e) {
//     return e;
//   }
// };

// export const handleForceUpdateError = (error: AxiosError) => {
//   try {
//     return _handleForceUpdateError(error);
//   } catch (e) {
//     return e;
//   }
// };

// export const handleMaintenanceError = (error: AxiosError) => {
//   try {
//     return _handleMaintenanceError(error);
//   } catch (e) {
//     return e;
//   }
// };

// export const handlePayApiError = (error: PayApiError) => {
//   try {
//     if (error.throwException) {
//       throw error;
//     }
//     return handlePayApiErrorFactory((errMsg) => alert(errMsg))(error);
//   } catch (e) {
//     return e;
//   }
// };

// export const handlePaySecAuthError = (error: AxiosError) => {
//   try {
//     return handlePaySecAuthErrorFactory(() =>
//       alert('TODO: 페이증권 인증 오류 어떻게 할까?')
//     )(error);
//   } catch (e) {
//     return e;
//   }
// };

// export const handlePaySecApiError = (error: PaySecApiError) => {
//   try {
//     if (error.throwException) {
//       throw error;
//     }
//     return handlePaySecApiErrorFactory('mutate', (_: unknown, errMsg: string) =>
//       alert(errMsg)
//     )(error);
//   } catch (e) {
//     return e;
//   }
// };

/**
 * 서버로 요청을 보내기 전 data나 params를 snake_case로 바꾸기 위한 인터셉터
 * @param config: AxiosRequestConfig
 * @returns AxiosRequestConfig;
 */
export const convertToSnakeCaseOnRequest = (config: AxiosRequestConfig) => {
  const { params, data } = config;

  return {
    ...config,
    params: params ? snakecaseKeys(params, { deep: true }) : undefined,
    data: data ? snakecaseKeys(data, { deep: true }) : undefined,
  };
};

/**
 * 정상 응답이 내려온 경우 data를 camelCase로 바꾸기 위한 인터셉터
 * @param res: AxiosResponse
 * @returns Promise.resolve(AxiosError);
 */
export const convertToCamelCaseOnResponse = async (res: AxiosResponse) => {
  return Promise.resolve({
    ...res,
    data: res?.data ? camelcaseKeys(res?.data, { deep: true }) : undefined,
  });
};

/**
 * 에러 응답이 내려온 경우 data를 camelCase로 바꾸기 위한 인터셉터
 * @param error AxiosError
 * @returns Promise.reject(AxiosError);
 */
export const convertToCamelCaseOnError = (
  error: AxiosError<Record<string, unknown>>
) => {
  // 데이터가 있는 경우에만 변환을 진행하고, 없는 경우에는 원본 에러를 바로 내린다.
  if (error?.response?.data) {
    return Promise.reject({
      ...error,
      response: {
        ...error.response,
        data: camelcaseKeys(error.response.data, { deep: true }),
      },
    });
  }
  return Promise.reject(error);
};

/**
 * 앱이 Focus 상태가 아닐떄 요청을 잠시 대기시키는 인터셉터
 * @param config AxiosRequestConfig
 * @returns Promise.resolve(config)
 */
export const suspendRequestOnPause = (config: AxiosRequestConfig) => {
  if (!appVisibility.isFocused) {
    return new Promise((resolve) => {
      appVisibility.callOnResumed(() => {
        resolve(config);
      });
    });
  }

  return Promise.resolve(config);
};

/**
 * 페이 증권 계정계 공통 에러일 경우 에러 메시지를 노출할 수 있게끔 showErrorMessage 값을 true로 지정한다.
 * @param error AxiosError
 */
// export const showErrorMessageWhenPaySecCommonAccountError = (
//   error: ExtendedAxiosError
// ) => {
//   if (
//     error?.response?.data?.errorCode &&
//     COMMON_ACCOUNT_ERROR_CODE_LIST.includes(error.response.data.errorCode)
//   ) {
//     error.showErrorMessage = true;
//   }

//   throw error;
// };

/**
 * API Cancel Error의 경우 error를 Consume하는 함수
 * @param error AxiosError
 * @returns void
 */
export const avoidCancelError = (error: AxiosError) => {
  if (axios.isCancel(error)) {
    console.log('Request canceled', error);
    return;
  }
  throw error;
};
